import { useEffect, useState } from "react";

const DURATION = 17 * 60 + 34; // 00:17:34
const START = Date.now();

function pad(n: number) {
  return n.toString().padStart(2, "0");
}

export function useCountdown() {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.floor((now - START) / 1000);
  const remaining = DURATION - (elapsed % (DURATION + 1));

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  };
}
